import React from "react";
import axios from "axios";
import { BACKEND_URL } from "../config/Constant";
import api from "../utils/axiosInstance";

const API = "assitant";



export const createOneVoiceAssistant = async (data) => {
    try {
      const response = await api.post(`${BACKEND_URL}/${API}/create`, data);
      return response;
    } catch (error) {
      return error;
    }
  };

  export const getVoiceAssitant = async () => {
    try {
      const response = await api.post(`${BACKEND_URL}/${API}/assitant`, null);
      return response;
    } catch (error) {
      return error;
    }
  };

  export const getOneAssistant = async (id) => {
    const data={
        Id:id
    }
    try {
      const response = await api.post(`${BACKEND_URL}/${API}/getassitant`, data);
      return response;
    } catch (error) {
      return error;
    }
  };


  export const getVoiceList = async () => {
  
    try {
      const response = await api.post(`${BACKEND_URL}/${API}/get-voices`, null);
      return response;
    } catch (error) {
      return error;
    }
  };

  
export const updateVoiceAssistant = async (data) => {
  try {
    const response = await api.post(`${BACKEND_URL}/${API}/updateassitant`, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const updateOneVoice = async (data) => {
  try {
    const response = await api.post(`${BACKEND_URL}/${API}/updatevoice`, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const createTransferToHuman = async (data) => {
  try {
    const response = await api.post(`${BACKEND_URL}/${API}/addtransfertohuman`, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteTransferToHuman = async (data) => {
  try {
    const response = await api.post(`${BACKEND_URL}/${API}/removetransfertoagent`, data);
    return response;
  } catch (error) {
    return error;
  }
};





